<template v-id="user" src="./html/ChangePassword.html"></template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth', 'currentUser'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-change-password',
				},

				loading: false,

				data: {
					password: null,
					password_confirmation: null,
				},

				type: {
					password: 'password',
					password_confirmation: 'password',
				}
			}
		},
		mounted() {
			this.$validator.extend('verify_password', {
				getMessage: field => 'La contraseña debe contener al menos: 1 letra mayúscula, 1 letra minúscula.',
				validate: value => {
					var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})")
					return strongRegex.test(value)
				}
			});
		},
		methods: {
			open() {
				this.clearData()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.errors.clear()
				this.data.password = null
				this.data.password_confirmation = null
			},
			changeType(type) {
				if(type == 'password') {
					if(this.type.password == 'text') {
						this.type.password = 'password'
					} else {
						this.type.password = 'text'
					}
					this.$refs.password.focus()
				}
				if(type == 'password_confirmation') {
					if(this.type.password_confirmation == 'text') {
						this.type.password_confirmation = 'password'
					} else {
						this.type.password_confirmation = 'text'
					}
					this.$refs.password_confirmation.focus()
				}
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.changePassword()
					}
				})
			},
			changePassword () {
				this.loading = true
				this.$http.post('admin/users/' + this.currentUser.id + '/change/password', this.data)
				.then(response => {
					this.loading = false
					this.clearData()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
					this.close()
				}).catch(function(response) {
					this.loading = false
					if(response.status == 409) {
						swal({
							title: response.statusText,
							text: response.bodyText,
							type: 'warning',
						})
					}
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/users/views/ChangePassword.vue